import { FC } from 'react'

import useSelectedDashboardStore from 'src/stores/useSelectedDashboardStore'
import Separator from '../../atoms/Separator'
import { usePageHeaderContext } from '../PageHeader/PageHeaderProvider'
import DeleteDashboardMenu from './components/DeleteDashboardMenu'
import DownloadDashboardMenu from './components/DownloadDashboardMenu'
import RenameDashboardMenu from './components/RenameDashboardMenu'
import SendDashboardMenuItem from './components/SendDashboardMenu'
import SetAsDefaultDashboardMenuItem from './components/SetAsDefaultDashboardMenuItem'

const PageHeaderDashboardMenuPopup: FC = () => {
  const { exportDashboardComponentCode, printModeAllowed } = usePageHeaderContext()
  const selectedDashboard = useSelectedDashboardStore(s => s.selectedDashboard)
  const isDefaultDashboard = selectedDashboard?.default_dashboard

  const isWithAction = selectedDashboard && !isDefaultDashboard

  return (
    <div role="menu">
      {exportDashboardComponentCode && <SendDashboardMenuItem />}
      {printModeAllowed && <DownloadDashboardMenu />}
      {isWithAction && (
        <>
          <Separator className="my-1" />
          <SetAsDefaultDashboardMenuItem />
          <RenameDashboardMenu />
          <DeleteDashboardMenu />
        </>
      )}
    </div>
  )
}

export default PageHeaderDashboardMenuPopup
